import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useTopicVideos({ topicID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addVideo(data = {}) {
    return privateFetch.post(`/v1/admin/video/clone`, data).then((res) => res.data);
  }

  function manageVideos({ data = {} } = {}) {
    return addVideo(data);
  }

  return useMutation(manageVideos, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('topic-details');
    },
  });
}

export default useTopicVideos;
